import { Box } from "@mui/material";

export default function TitlePayment({ children }) {
    return (
        <Box
            sx={{ fontSize: "1rem", fontWeight: "bold", padding: "0 0 5px 0" }}
        >
            {children}
        </Box>
    );
}

export function PreTitlePayment({ children }) {
    return (
        <Box
            sx={{
                fontSize: "0.8rem",
                fontWeight: "bold",
                padding: "0 0 4px 0",
                color: "#999",
            }}
        >
            {children}
        </Box>
    );
}
